import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const app = initializeApp({
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
});

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export const functions = getFunctions(app);
export const analytics = (await isSupported()) ? getAnalytics(app) : null;

export { logEvent };

export default app;

// Check if we are running in the emulator environment
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
	// Connect to the Auth emulator
	connectAuthEmulator(auth, 'http://localhost:9099');

	// Connect to the Functions emulator
	connectFunctionsEmulator(functions, 'localhost', 5001);

	// Connect to the Firestore emulator
	connectFirestoreEmulator(db, 'localhost', 8080);
}
